import React, { Component } from 'react';
import {
	Collapse, Navbar,
	NavbarToggler,
	Nav,
	NavItem,
	NavLink,
	NavbarBrand
} from 'reactstrap';
import './NavBar.css';
import Scrollspy from 'react-scrollspy';

class NavBar extends Component {

	render() {
		const navItems = this.props.navMenu.map(item => {
			return item.title
		});

		const [about, lawyers, support, contact] = navItems;

		return (
			<Scrollspy items={['section-1', 'section-2', 'section-3', 'section-4']}>
				<Navbar light expand='md'>
					<NavbarToggler onClick={this.props.toggle} />
					<NavbarBrand id='showOnCollapse'>MENU</NavbarBrand>
					<Collapse isOpen={this.props.isOpen} navbar className={this.props.sticky ? 'dropDown' : 'dropUp'}>
						<Nav className="ml-xl-5 pl-5" navbar >
							<NavItem>
								<NavLink onClick={this.props.About}>{about}</NavLink>
							</NavItem>
							<NavItem>
								<NavLink onClick={this.props.Lawyers}>{lawyers}</NavLink>
							</NavItem>
							<NavItem>
								<NavLink onClick={this.props.Support}>{support}</NavLink>
							</NavItem>
							<NavItem>
								<NavLink onClick={this.props.Contact}>{contact}</NavLink>
							</NavItem>
							<NavItem>
								<NavLink onClick={this.props.languageSwitcher} className='hoverable'>
									<span className={this.props.lang === 'en' ? 'white' : ''}>EN</span>|
                                    <span className={this.props.lang === 'de' ? 'white' : ''}>DE</span>
								</NavLink>
							</NavItem>
						</Nav>
					</Collapse>
				</Navbar >
			</Scrollspy >
		)
	}
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js